<template>
	<div class="cmbc_detail bg_FFFFFF width_100">
		<naviBack type='detail' title="" background="none" />
		<div class="cmbc_detail_swiper width_100">
			<van-swipe :autoplay="5000" @change="swiperChange" :show-indicators="false">
				<van-swipe-item v-for="(item_sw,index_sw) in 4" :key="'sw'+index_sw">
					<van-image class="cmbc_detail_swiper_item width_100" fit="cover" src="https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20260104_6cwEPkyn64R8M7r.png" />
				</van-swipe-item>
			</van-swipe>
			<div class="cmbc_detail_swiper_ind display_center_center">
				<div :class="[{'cmbc_detail_swiper_ind_itemS':cur_swi_index==index_ind},'cmbc_detail_swiper_ind_item']"
					v-for="(item_ind,index_ind) in 4" :key="'ind'+index_ind"></div>
			</div>
		</div>
		<div class="cmbc_detail_body width_100 border_radius_16">
			<div class="cmbc_detail_body_1 width_100 font_size_36 color_333333 font_weight_600">单次游泳</div>
			<div class="cmbc_detail_body_2 width_100 border_radius_16 bg_FFFFFF">
				<div class="cmbc_detail_body_21">
					<div class="cmbc_detail_body_211 width_100 font_size_30 color_333333">北京爱尚健身馆（冠城店）</div>
					<div class="cmbc_detail_body_212 color_999999 font_size_24 width_fit text_ellipsis">北京市海淀区马甸东路冠城北园1号楼南门内</div>
				</div>
			</div>
			
			<div class="cmbc_detail_body_4 width_100 border_radius_16 bg_FFFFFF">
				<div class="width_fit text_ellipsis2 display_start_center">
					<div v-for="(item_stock,index_stock) in 14" :key="'stock'+index_stock" 
					class="cmbc_detail_body_4_item border_radius_8 display_center_center text_align_center">
						<div class="width_100">
							<div class="cmbc_detail_body_4_item_1 color_333333 font_size_28 font_weight_600">周日</div>
							<div class="cmbc_detail_body_4_item_2 color_333333 font_size_24 ">01.04</div>
							<div class="cmbc_detail_body_4_item_3   bg_F77F28  display_between_center">
								<div class="color_ffffff font_size_24 width_100 display_between_center">预定</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cmbc_detail_body_3 width_100 border_radius_16 bg_FFFFFF">
				<div class="width_100 font_size_30 color_333333 font_weight_600">预约须知</div>
				<div class="cmbc_detail_body_32 width_100 font_size_26 color_666666">
					1.此服务为单次游泳，全天营业时间内通用；
					2.全部店内游泳池、更衣室、洗浴房使用；
					3.预约成功后，请在预约时间至门店核销使用；
					4.根据健身中心规定，为安全起见，游泳不接收年龄在70周岁以上(包含70岁)的客人进入未成年人下场时需成年人陪同进入(双方均需付费入场);
					5.预约场所内设施的使用须遵守该商家的规定，例如使用者的年龄限制、健身设施的开放时间，以及不得妨碍他人等。如严重违反任一酒店健身中心的相关规定，后果由其本人负责:
					6.请勿进行任何形式的游泳教学行为，若因此被禁止使用该场馆，后果由用户自行承担。
				</div>
				<div class="cmbc_detail_body_31 width_100 font_size_30 color_333333 font_weight_600">预约须知</div>
				<div class="cmbc_detail_body_32 width_100 font_size_26 color_666666">
					1.此服务为单次游泳，全天营业时间内通用；
					2.全部店内游泳池、更衣室、洗浴房使用；
					3.预约成功后，请在预约时间至门店核销使用；
					4.根据健身中心规定，为安全起见，游泳不接收年龄在70周岁以上(包含70岁)的客人进入未成年人下场时需成年人陪同进入(双方均需付费入场);
					5.预约场所内设施的使用须遵守该商家的规定，例如使用者的年龄限制、健身设施的开放时间，以及不得妨碍他人等。如严重违反任一酒店健身中心的相关规定，后果由其本人负责:
					6.请勿进行任何形式的游泳教学行为，若因此被禁止使用该场馆，后果由用户自行承担。
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import naviBack from '../components/navi_back.vue';
	export default {
		components: {
			naviBack
		},
		name: "",
		data() {
			return {
				cur_swi_index:0,
			};
		},
		mounted() {
			
		},
		methods: {
			swiperChange(e){
				this.cur_swi_index=e
			},
		},
	};
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750 * 100vw;
	.cmbc_detail{
		min-height: 100vh;
		background: #F6F7F9;
		.cmbc_detail_swiper{
			position: relative;
			.cmbc_detail_swiper_item{
				height: 580*@vm_base;
			}
			.cmbc_detail_swiper_ind{
				position: absolute;
				bottom: 60*@vm_base;
				right: 30*@vm_base;
				.cmbc_detail_swiper_ind_item{
					width: 10*@vm_base;
					height: 10*@vm_base;
					background: rgba(255,255,255,0.4);
					border-radius: 50%;
					margin-left: 5*@vm_base;
				}
				.cmbc_detail_swiper_ind_itemS{
					background: rgba(255,255,255,1);
				}
			}
		}
		.cmbc_detail_body{
			background: #F6F7F9;
			padding: 30*@vm_base 20*@vm_base;
			padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 30*@vm_base);
			padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);
			.cmbc_detail_body_1{
				padding: 0 20*@vm_base;
				line-height: 1.3;
			}
			.cmbc_detail_body_2{
				margin-top: 20*@vm_base;
				padding: 24*@vm_base 30*@vm_base;
				.cmbc_detail_body_21{
					.cmbc_detail_body_211{
						padding-left: 50*@vm_base;
						line-height: calc(40 / 30);
						background-image: url(../resource/location.png);
						background-position: left top;
						background-repeat: no-repeat;
						background-size: auto 40*@vm_base;
					}
					.cmbc_detail_body_212{
						padding-left: 50*@vm_base;
						margin-top: 10*@vm_base;
						line-height: calc(34 / 24);
						max-width: 100%;
						padding-right: 40*@vm_base;
						background-image: url(../resource/fly.png);
						background-position: right center;
						background-repeat: no-repeat;
						background-size: auto 100%;
					}
				}
			}
			.cmbc_detail_body_3{
				padding: 30*@vm_base;
				margin-top: 20*@vm_base;
				.cmbc_detail_body_31{
					margin-top: 20*@vm_base;
				}
				.cmbc_detail_body_32{
					line-height: calc(42 / 26);
					margin-top: 16*@vm_base;
				}
			}
			.cmbc_detail_body_4{
				padding: 30*@vm_base 0;
				margin-top: 20*@vm_base;
				overflow: hidden;
				overflow-x: auto;
				&::-webkit-scrollbar{
					width: 0;
					height: 0;
				}
				.cmbc_detail_body_4_item{
					width: 160*@vm_base;
					border: 1*@vm_base solid #D9D9D9;
					margin-right: 20*@vm_base;
					padding: 24*@vm_base 0 60*@vm_base 0;
					position: relative;
					&:first-child{
						margin-left: 30*@vm_base;
					}
					&:last-child{
						margin-right: 30*@vm_base;
					}
					.cmbc_detail_body_4_item_1{
						line-height: 1.3;
					}
					.cmbc_detail_body_4_item_2{
						line-height: 1.3;
					}
					.cmbc_detail_body_4_item_3{
						position: absolute;
						bottom: -1*@vm_base;
						left: -1*@vm_base;
						width: calc(100% + 2*@vm_base);
						line-height: 1.2;
						padding: 6*@vm_base 10*@vm_base 6*@vm_base 20*@vm_base;
						border-radius: 0 0 8*@vm_base 8*@vm_base;
						div{
							line-height: 1.4;
							background-image: url(../resource/more_ffffff.png);
							background-position: right center;
							background-repeat: no-repeat;
							background-size: auto 92%;
						}
					}
				}
			}
		}
		/*
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 25*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 25*@vm_base);
		*/
		
	}
</style>


// WEBPACK FOOTER //
// src/views/detail_2.vue